import {
  ADD_TO_COMPARISON_LIST_FAIL,
  ADD_TO_COMPARISON_LIST_SUCCESS,
  COMPARISON_LIST_FULL,
  POPULATE_INITIAL_COMPARISON_LIST,
  REMOVE_ALL_FROM_COMPARISON_FAIL,
  REMOVE_ALL_FROM_COMPARISON_SUCCESS,
  REMOVE_FROM_COMPARISON_LIST_FAIL,
  REMOVE_FROM_COMPARISON_LIST_SUCCESS,
} from "./actions";
import { type ProductComparisonState } from "./types";

export const initialState: ProductComparisonState = {
  comparisonList: [],
};

export const productComparisonReducer = (state = initialState, action: any): ProductComparisonState => {
  switch (action.type) {
    case POPULATE_INITIAL_COMPARISON_LIST: {
      const data = action.payload;
      return { ...state, comparisonList: data };
    }
    case ADD_TO_COMPARISON_LIST_SUCCESS: {
      const data = action.payload as string;
      return {
        ...state,
        comparisonList: [...state.comparisonList, data],
      };
    }
    case REMOVE_FROM_COMPARISON_LIST_SUCCESS: {
      const data = action.payload as string;
      const idExists = state.comparisonList.find((id) => id === data);
      if (idExists) {
        return {
          ...state,
          comparisonList: state.comparisonList.filter((id) => id !== data),
        };
      }
      return {
        ...state,
      };
    }
    case ADD_TO_COMPARISON_LIST_FAIL: {
      return {
        ...state,
      };
    }
    case COMPARISON_LIST_FULL: {
      return {
        ...state,
      };
    }
    case REMOVE_FROM_COMPARISON_LIST_FAIL: {
      return {
        ...state,
      };
    }
    case REMOVE_ALL_FROM_COMPARISON_SUCCESS: {
      return {
        ...state,
        comparisonList: [],
      };
    }
    case REMOVE_ALL_FROM_COMPARISON_FAIL: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
